/** 事件总线 */
import Vue from 'vue';
export const Bus = new Vue()